import React, { Component } from "react";
import Kenny from './../avatars/Kenny';
import Brenda from './../avatars/Brenda';
import Boss from './../avatars/Boss';

class Avatar extends Component {

    // constructor(props) {
	// 	super( props );
	// 	this.state = {
	// 		twitterAccount: "",
	// 		ranking: 0
	// 	};
    // }	

    componentDidMount () {
        // console.log(this.props)
    }

    getAvatar () {
        if (this.props.round === 1) return <Kenny look={this.props.look} speaking={ this.props.speaking } />
        if (this.props.round === 2) return <Brenda look={this.props.look} speaking={ this.props.speaking } />
        if (this.props.round === 3) return <Boss look={this.props.look} speaking={ this.props.speaking } />
        // {this.props.round} {this.props.look}
    }

    render() {
        return (
            <div className={`avatar`}>
                {
                    this.getAvatar()
                }
            </div>
        );
    }
};

export default Avatar;


// WEBPACK FOOTER //
// ./src/components/darkpatterns2d/Avatar.js